import React, { useMemo } from 'react';

export default function ParticlesBackground() {
  const particles = useMemo(() =>
    Array.from({ length: 20 }, (_, i) => ({
      id: i,
      left: Math.random() * 100,
      size: 3 + Math.random() * 6,
      duration: 15 + Math.random() * 25,
      delay: Math.random() * 15,
      opacity: 0.08 + Math.random() * 0.15,
    })),
    []
  );

  return (
    <div
      style={{
        position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
        pointerEvents: 'none', zIndex: 0, overflow: 'hidden',
        background: 'linear-gradient(135deg, #ecfdf5 0%, #d1fae5 30%, #f0fdf4 100%)',
      }}
    >
      {/* Large gradient orbs */}
      <div style={{
        position: 'absolute', width: 600, height: 600, borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(16,185,129,0.08) 0%, transparent 70%)',
        top: -200, right: -200,
        animation: 'float 20s ease-in-out infinite',
      }} />
      <div style={{
        position: 'absolute', width: 800, height: 800, borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(52,211,153,0.06) 0%, transparent 70%)',
        bottom: -300, left: -300,
        animation: 'float 25s ease-in-out infinite reverse',
      }} />
      <div style={{
        position: 'absolute', width: 400, height: 400, borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(110,231,183,0.07) 0%, transparent 70%)',
        top: '40%', left: '40%',
        animation: 'float 18s ease-in-out infinite 5s',
      }} />

      {/* Floating particles */}
      {particles.map(p => (
        <div
          key={p.id}
          style={{
            position: 'absolute',
            left: `${p.left}%`,
            bottom: '-10px',
            width: p.size,
            height: p.size,
            borderRadius: '50%',
            background: `rgba(16, 185, 129, ${p.opacity})`,
            animation: `particle-float ${p.duration}s linear infinite`,
            animationDelay: `${p.delay}s`,
          }}
        />
      ))}
    </div>
  );
}
